import {atom} from "recoil";
import keys from "configs/atoms";

const lookupLandingPagesAtom = atom(({
    key: keys.Lookup.LandingPages,
    default: []//lookupStatsDatesSelector
}));

export default lookupLandingPagesAtom;